import React from 'react'
import Box from '@material-ui/core/Box'
import PageHeading from '../../components/page-heading'

// MG: stubbing this out in case we need to customize this page specific to
// whether it was a consumer or a pga member that logged out
//
// const referrerPath = document.referrer.replace(window.location.origin, '')
// if (referrerPath.startsWith('/consumer/v1/logout')) {
//   // consumer logged out
// } else if (referrerPath.startsWith('/v2/logout')) {
//   // pga member logged out
// }

const LogoutPage = () => {
  return (
    <Box mb={5}>
      <PageHeading
        heading="You have successfully signed out"
        subheading="Close this window to end your session"
      />
    </Box>
  )
}

export default LogoutPage
